import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAU1u9eLX_WrMMyskc90fBxsZ5fHClLqCs",
  authDomain: "yakirli.firebaseapp.com",
  projectId: "yakirli",
  storageBucket: "yakirli.appspot.com",
  messagingSenderId: "631442302502",
  appId: "1:631442302502:web:18326db9ae55a68d1268e7",
  measurementId: "G-LGZMBT6F6W",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
